
// function detectBrowser() {

//     let userAgent = navigator.userAgent;
//     let browserName;
  
//     if (userAgent.match(/chrome|chromium|crios/i)) {
//       browserName = "Chrome";
//     } else if (userAgent.match(/firefox|fxios/i)) {
//       browserName = "Firefox";
//     } else if (userAgent.match(/safari/i)) {
//       browserName = "Safari";
//     } else if (userAgent.match(/opr\//i)) {
//       browserName = "Opera";
//     } else if (userAgent.match(/edg/i)) {
//       browserName = "Edge";
//     } else if (userAgent.match(/android/i)) {
//       browserName = "Android";
//     } else if (userAgent.match(/iphone/i)) {
//       browserName = "iPhone";
//     } else {
//       browserName = "Unknown";
//     }

//     return browserName;

// }

jQuery(document).ready(function() {

    if(jQuery('section#solutions video').length) {

        /* The encoding is super important here to enable frame-by-frame scrubbing. */
        // ffmpeg -i ~/Downloads/Toshiba\ video/original.mov -movflags faststart -vcodec libx264 -crf 23 -g 1 -pix_fmt yuv420p output.mp4
        // ffmpeg -i ~/Downloads/Toshiba\ video/original.mov -vf scale=960:-1 -movflags faststart -vcodec libx264 -crf 20 -g 1 -pix_fmt yuv420p output_960.mp4

        video_start = jQuery('section#solutions video').offset().top;
        video_end = video_start + jQuery('section#solutions video').outerHeight();
        //console.log('Video start : '+video_start+', video end : '+video_end);

        var video_loaded = false;
        document.addEventListener('windowScroll', (e) => {
            //console.log('Scroll : '+current_scroll);
            if(video_loaded == false && current_scroll > 1500) {
                //console.log('Load video');
                video_loaded = true;

                const video = document.querySelector('section#solutions video');
                let src = video.currentSrc || video.src;

                /* Make sure the video is 'activated' on iOS */
                function once(el, event, fn, opts) {
                    var onceFn = function (e) {
                        el.removeEventListener(event, onceFn);
                        fn.apply(this, arguments);
                    };
                    el.addEventListener(event, onceFn, opts);
                    return onceFn;
                }

                once(document.documentElement, "touchstart", function (e) {
                    video.play();
                    video.pause();
                });

                /* ---------------------------------- */
                /* Scroll Control! */
                let tl = gsap.timeline({
                    defaults: { duration: 1 },
                    scrollTrigger: {
                        trigger: "#solutions",
                        start: "top bottom",
                        end: "bottom top",
                        scrub: true,
                        //markers: true
                    }
                });

                once(video, "loadedmetadata", () => {
                    tl.fromTo(
                        video,
                        { currentTime: 0 },
                        { currentTime: video.duration || 1 }
                    );
                });

                // When first coded, the Blobbing was important to ensure the browser wasn't dropping previously played segments, 
                // but it doesn't seem to be a problem now. 
                // Possibly based on memory availability?
                setTimeout(function () {
                    video.play();
                    video.pause();
                    var t = video.currentTime;
                    video.currentTime = t + 0.01;
                    
                    // if (window["fetch"]) {
                    //     console.log("fetch");
                    //     fetch(src)
                    //     .then((response) => response.blob())
                    //     .then((response) => {
                    //         console.log(response);
                    //         var blobURL = URL.createObjectURL(response);
                    //         console.log(blobURL);

                    //         var t = video.currentTime;
                    //         // once(document.documentElement, "touchstart", function (e) {
                    //         //     video.play();
                    //         //     video.pause();
                    //         // });

                    //             video.play();
                    //             video.pause();

                    //         //video.setAttribute("src", blobURL);
                    //         video.currentTime = t + 0.01;
                    //     });
                    // }
                }, 1000);
                /* ---------------------------------- */
            }
        }, false);

        

        

        // Vérifiez si l'utilisateur utilise Safari sur un appareil iOS
        // cette méthode n'est pas infaillible et peut ne pas fonctionner avec toutes les versions de Safari et de iOS. 
        // Si besoin d'une solution plus fiable, utiliser unebibliothèque tierce comme Mobile-Detect https://github.com/hgoebl/mobile-detect.js

        // if( detectBrowser() == 'Safari' /* && "ontouchstart" in document.documentElement */ ) { // 2eme partie pour detecter mobile == iOS
        //     //console.log('L\'utilisateur utilise Safari');
        //     // Remplacer video par iframe Vimeo
        //     jQuery('#solutions video').addClass('d-none');
        //     // <iframe src="https://player.vimeo.com/video/782864852?h=16c945ad6d&badge=0&autopause=0&player_id=0&app_id=58479&background=1" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" title="video_fond_solutions_fx_couleur.mp4" playsinline muted></iframe>

        //     let scriptEle = document.createElement("script");
        //     scriptEle.setAttribute("src", "https://player.vimeo.com/api/player.js");
        //     scriptEle.setAttribute("type", "text/javascript");
        //     scriptEle.setAttribute("async", true);
          
        //     document.body.appendChild(scriptEle);

        //     scriptEle.addEventListener("load", () => {

        //         let vimeoIframe = document.createElement("iframe");
        //         vimeoIframe.setAttribute("src", "https://player.vimeo.com/video/782864852?h=16c945ad6d&badge=0&autopause=0&player_id=0&app_id=58479&background=1");
        //         vimeoIframe.setAttribute("frameborder", "0");
        //         vimeoIframe.setAttribute("allow", "autoplay; fullscreen; picture-in-picture");
        //         vimeoIframe.setAttribute("playsinline", "");
        //         vimeoIframe.setAttribute("muted", "");
        //         document.getElementById('video_safari_mobile').appendChild(vimeoIframe);
        //         jQuery('#video_safari_mobile').removeClass('d-none');

        //     });
            
        // }

    }
});